import groq from 'groq';

export const AMAZON_BUTTON = groq`
  amazonButton {
    hasAmazonButton,
    overrideUrl
  }
`;
